/* Auvra cart: "Make it a Pair" variant swap. Removes the One-tier line, adds the Pair variant. */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-auvra-upsell-swap]');
    if (!btn) return;
    e.preventDefault();
    btn.disabled = true;
    var lineKey = btn.getAttribute('data-line-key');
    var pairId = btn.getAttribute('data-pair-id');
    fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/change.js' : '/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 0 })
    }).then(function () {
      return fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(pairId, 10), quantity: 1 }] })
      });
    }).then(function () { window.location.reload(); })
      .catch(function () { btn.disabled = false; });
  });
})();
